import React from "react";
import ReactDOM from "react-dom";
import { InsertDriveFileOutlined } from "@material-ui/icons";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { FormControlLabel, ThemeProvider } from "@material-ui/core";
import { groopTheme } from "../styles/MaterialGroopTheme";
import { makeStyles } from "@material-ui/core/styles";

interface ExtractionSourceEditorProps {
  extractionSourceIdId: string; // extractionSourceId
  extractionSourceIdName: string; // ExtractionSource_Id
  extractionSourceIdValue: string; // The Id of the extraction.
  extractionSourceIncludeSourceId: string; // ExtractionSource_IncludeSource
  extractionSourceIncludeSourceName: string; // ExtractionSource.IncludeSource
  extractionSourceIncludeSourceValue: boolean; // true or false
  extractionSourceValueId: string; // extractionSourceValue
  extractionSourceValueName: string; // ExtractionSource.Value
  extractionSourceValue: string; // The text value of the extraction source
  groopItId: string;
}

const useStyles = makeStyles({
  checkbox: {
    paddingLeft: "7px",
    paddingRight: "4px",
    "&:hover": {
      backgroundColor: "transparent !important",
    },
  },
});

export const ExtractionSourceEditor = (
  props: ExtractionSourceEditorProps,
): JSX.Element => {
  const [included, setIncluded] = React.useState<boolean>(
    props.extractionSourceIncludeSourceValue,
  );

  const [shouldShowExtractionSource, setShouldShowExtractionSource] =
    React.useState<boolean>(true);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIncluded(event.target.checked);
  };

  const handleDeleteExtractionSource = async () => {
    setShouldShowExtractionSource(false);
  };

  const style = useStyles();

  return (
    <>
      {shouldShowExtractionSource && (
        <ThemeProvider theme={groopTheme}>
          <hr className="small-divider" />
          <input
            type="hidden"
            id={props.extractionSourceIncludeSourceId}
            name={props.extractionSourceIncludeSourceName}
            value={included ? "True" : "False"}
          />
          <input
            type="hidden"
            id={props.extractionSourceIdId}
            name={props.extractionSourceIdName}
            value={props.extractionSourceIdValue}
          />
          <div className="groop-item">
            <div className="flex justify-between items-center">
              <span>
                <InsertDriveFileOutlined
                  className="mr-3"
                  color="primary"
                ></InsertDriveFileOutlined>
                Source
              </span>
              <button
                className="component-delete"
                type="button"
                onClick={handleDeleteExtractionSource}
                aria-label="Delete source"
              >
                <img src="/Content/Images/ic_delete.svg" alt="Trash can icon" />
              </button>
            </div>
            <div className="ml-9">
              <textarea
                className="form-control"
                id={props.extractionSourceValueId}
                defaultValue={props.extractionSourceValue}
                name={props.extractionSourceValueName}
                readOnly
              ></textarea>
            </div>
            <div className="flex ml-10 text-display-subtitle">
              <FormControlLabel
                control={
                  <Checkbox
                    className={style.checkbox}
                    checked={included}
                    checkedIcon={
                      <CheckBoxIcon
                        style={{ fill: "black" }}
                        fontSize="small"
                      />
                    }
                    disableRipple
                    icon={
                      <CheckBoxOutlineBlankIcon
                        style={{ fill: "black" }}
                        fontSize="small"
                      />
                    }
                    size="small"
                    onChange={handleSwitchChange}
                  ></Checkbox>
                }
                label="Include in Feed"
              ></FormControlLabel>
            </div>
          </div>
        </ThemeProvider>
      )}
    </>
  );
};

const extractionSourceEditor = document.querySelector(
  ".extraction-source-editor",
) as HTMLElement;

if (extractionSourceEditor) {
  ReactDOM.render(
    <ExtractionSourceEditor
      extractionSourceIdId={
        extractionSourceEditor.dataset.extractionSourceIdId as string
      }
      extractionSourceIdName={
        extractionSourceEditor.dataset.extractionSourceIdName as string
      }
      extractionSourceIdValue={
        extractionSourceEditor.dataset.extractionSourceIdValue as string
      }
      extractionSourceIncludeSourceId={
        extractionSourceEditor.dataset.extractionSourceIncludeSourceId as string
      }
      extractionSourceIncludeSourceName={
        extractionSourceEditor.dataset
          .extractionSourceIncludeSourceName as string
      }
      extractionSourceIncludeSourceValue={
        extractionSourceEditor.dataset.extractionSourceIncludeSourceValue ===
        "True"
      }
      extractionSourceValueId={
        extractionSourceEditor.dataset.extractionSourceValueId as string
      }
      extractionSourceValueName={
        extractionSourceEditor.dataset.extractionSourceValueName as string
      }
      extractionSourceValue={
        extractionSourceEditor.dataset.extractionSourceValue as string
      }
      groopItId={extractionSourceEditor.dataset.groopItId as string}
    />,
    extractionSourceEditor,
  );
}
